<template>
    <div class="labels-wrapper">
        <div class="left-label" :style="labelStyle">
            <div class="label-text">
                {{leftLabel}}
            </div>
        </div>
        <div class="right-label" :style="labelStyle">
            <div class="label-text">
                {{rightLabel}}
            </div>
        </div>
    </div>
</template>

<script>
import { getRightLabel, getLeftLabel } from '../../../helpers/streams';
import helper from '../../../helpers/helper';

export default {
    name: 'PlayerHighlightLabels',
    props: {
        item: { type: Object }
    },
    computed: {
        rightLabel() {
            return getRightLabel(this.item.type);
        },
        leftLabel() {
            return getLeftLabel(this.item.type, this.item.attributes);
        },
        labelStyle() {
            const color = this.item.attributes.team.color;
            const isWhiteColor = color && color.toLowerCase().includes('#fff');

            if (isWhiteColor) {
                return {
                    backgroundColor: helper.getLabelBackgroundColor(color, 0.8),
                    backgroundImage: 'linear-gradient(rgba(0,0,0,0.15), rgb(0,0,0,0.15) 100%)',
                    textShadow: '1px 1px 1px #00000021'
                }
            }

            return {
                backgroundColor: this.backgroundColor
            }
        },
        backgroundColor() {
            const alpha = 0.5;
            return helper.getLabelBackgroundColor(this.item.attributes.team.color, alpha)
        }
    }
}
</script>
